module.exports = __webpack_public_path__ + "img/2.ae061edd.jpg";